import qs from 'qs'

import config from '../../config'
import { buildGetQuery } from '../../util'
import { QueryObserverOptions } from '@tanstack/react-query'

import { IGetRequestObject } from '../../interfaces'

import { ISafetyCaseActionType } from '../../interfaces/services/safety-case-action-type'

type QueryObject = {
  activeOnly?: boolean
}

const getSafetyCaseActionTypesRequest = (
  params: undefined,
  queryObject: QueryObject | undefined,
): IGetRequestObject => {
  const queryString = qs.stringify(queryObject, { addQueryPrefix: true })

  return {
    method: 'get',
    url: `${config.baseUrl}/sms/SafetyCaseActionTypes${queryString}`,
  }
}

const useSafetyCaseActionTypesQueryBase = buildGetQuery<
  undefined,
  QueryObject | undefined,
  ISafetyCaseActionType[] | undefined
>({
  getRequest: getSafetyCaseActionTypesRequest,
  getQueryKey: (params, queryObject) => ['safety-case-action-types', queryObject?.activeOnly],
})

const useSafetyCaseActionTypesQuery = (
  queryObject?: QueryObject,
  options?: QueryObserverOptions<ISafetyCaseActionType[] | undefined, Error>,
) => {
  const safetyCaseActionTypesQuery = useSafetyCaseActionTypesQueryBase(undefined, queryObject, options)

  return { ...safetyCaseActionTypesQuery }
}
export default useSafetyCaseActionTypesQuery
